var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [{ icon: "user-tie", page: _vm.page_title.toUpperCase() }],
        },
      }),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "mb-5",
              attrs: { color: "primary" },
              on: { click: _vm.legajoNew },
            },
            [_vm._v("Crear " + _vm._s(_vm.modal_title))]
          ),
          _vm.create_access
            ? _c(
                "v-btn",
                {
                  staticClass: "mb-5 ml-3",
                  attrs: { outlined: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialog_import = true
                    },
                  },
                },
                [_vm._v("Importar " + _vm._s(_vm.page_title))]
              )
            : _vm._e(),
          _vm.create_access
            ? _c("ModalImportExcel", {
                attrs: {
                  modal_title: "Importar " + _vm.page_title,
                  dialog: _vm.dialog_import,
                },
                on: {
                  updateDialog: (value) => (_vm.dialog_import = value),
                  loadList: function ($event) {
                    return _vm.loadList(_vm.service)
                  },
                },
              })
            : _vm._e(),
          _vm.list_access
            ? _c("v-card", { staticClass: "mb-5 px-4 py-10" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-6",
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-0",
                          attrs: { row: "", "hide-details": "" },
                          model: {
                            value: _vm.status,
                            callback: function ($$v) {
                              _vm.status = $$v
                            },
                            expression: "status",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: "Todos", value: "all" },
                          }),
                          _c("v-radio", {
                            attrs: { label: "Activos", value: "linked" },
                          }),
                          _c("v-radio", {
                            attrs: {
                              label: "Desvinculados",
                              value: "unlinked",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-6",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "end",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: { outlined: "", color: "primary" },
                          on: { click: _vm.exportToExcel },
                        },
                        [_vm._v("Exportar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.loadList(_vm.service)
                            },
                          },
                        },
                        [_vm._v("Buscar")]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.list_access
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c("span", { staticClass: "text-uppercase" }, [
                        _vm._v(_vm._s(_vm.page_title)),
                      ]),
                      _c("v-spacer"),
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: "Buscar",
                          "single-line": "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.list,
                      search: _vm.search,
                      loading: _vm.loading,
                      "loading-text": "Cargando...",
                      options: {
                        descending: true,
                        itemsPerPage: 15,
                      },
                      "footer-props": {
                        itemsPerPageOptions: [5, 10, 15, 50, -1],
                      },
                    },
                    on: { pagination: _vm.updatePagination },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item",
                          fn: function (props) {
                            return [
                              _c("tr", { staticStyle: { height: "50px" } }, [
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-avatar",
                                      { attrs: { size: "40" } },
                                      [
                                        props.item.photo_url
                                          ? _c("v-img", {
                                              attrs: {
                                                src: props.item.photo_url,
                                                alt: "Avatar",
                                              },
                                            })
                                          : _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "grey lighten-1",
                                                  size: "37",
                                                },
                                              },
                                              [_vm._v("mdi-account-circle")]
                                            ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.nro_legajo)),
                                ]),
                                _c("td", [_vm._v(_vm._s(props.item.name))]),
                                _c("td", [_vm._v(_vm._s(props.item.surname))]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(props.item.document_type.name) +
                                      " " +
                                      _vm._s(props.item.document) +
                                      " "
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      props.item.workstation != null
                                        ? props.item.workstation.name
                                        : "-"
                                    )
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.sucursal.name)),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      props.item.seniority != null
                                        ? props.item.seniority
                                        : "-"
                                    )
                                  ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _vm.isUnlinked(props.item)
                                      ? _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              small: "",
                                              color: "red lighten-4",
                                              "text-color": "red darken-3",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " Desvinculado " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    props.item.finish_date
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              small: "",
                                              color: "green lighten-4",
                                              "text-color": "green darken-3",
                                            },
                                          },
                                          [_vm._v("Activo")]
                                        ),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-center px-0 pr-3",
                                    staticStyle: { "min-width": "160px" },
                                  },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _vm.update_access
                                                    ? _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "blue",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.editItem(
                                                                  props.item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [_vm._v(" edit ")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [_c("span", [_vm._v("Editar")])]
                                    ),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _vm.update_access &&
                                                  !_vm.isUnlinked(props.item)
                                                    ? _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            staticClass: "mr-1",
                                                            attrs: {
                                                              small: "",
                                                              color: "orange",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.unlinkItem(
                                                                  props.item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " mdi-account-off "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [_c("span", [_vm._v("Desvincular")])]
                                    ),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _vm.delete_access
                                                    ? _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "red",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteItem(
                                                                  props.item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [_vm._v(" delete ")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [_c("span", [_vm._v("Eliminar")])]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "no-results",
                          fn: function () {
                            return [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    value: true,
                                    color: "error",
                                    icon: "warning",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "Busqueda sin resultados - " +
                                          _vm.search
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1731564211
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.update_access
            ? _c("ModalUnlink", {
                attrs: { dialog: _vm.dialog_unlink, legajo: _vm.legajo_unlink },
                on: {
                  updateDialog: (value) => (_vm.dialog_unlink = value),
                  loadList: function ($event) {
                    return _vm.loadList(_vm.service)
                  },
                },
              })
            : _vm._e(),
          _c("DialogDelete", {
            attrs: { dialog_delete: _vm.dialog_delete },
            on: {
              updateDialogDelete: _vm.updateDialogDelete,
              deleteItemConfirm: _vm.deleteItemConfirm,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }